import { render, staticRenderFns } from "./AndroidLikeSidebar.vue?vue&type=template&id=6c256132"
import script from "./AndroidLikeSidebar.vue?vue&type=script&lang=js"
export * from "./AndroidLikeSidebar.vue?vue&type=script&lang=js"
import style0 from "./AndroidLikeSidebar.vue?vue&type=style&index=0&id=6c256132&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports